import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.353 16h-1.34l-1.13-1.58-1.12 1.58h-1.33l1.79-2.52-1.69-2.37h1.35l1.01 1.43 1.02-1.43h1.32l-1.67 2.36zm-5.719-7v7h-1.16v-5.39l-1.58 1.28v-1.41L9.834 9z"
    }
  )
);
var SvgSpeed100XFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Speed100XFilled_default = SvgSpeed100XFilled;

export { Speed100XFilled_default as default };
